/**
 * tdesign v0.3.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { attachMethodsToComponent } from '../_util/attachMethodsToComponent.js';
import methods from './methods.js';
import './style/css.js';
import './type.js';
import '../_chunks/dep-c445dc73.js';
import '../_chunks/dep-5cf1fbb1.js';
import '../_chunks/dep-f771ed13.js';
import 'react';
import 'react-dom';
import './constant.js';
import './Toast.js';
import '../_chunks/dep-fc32874d.js';
import '../_chunks/dep-b3e4e8ba.js';
import 'tdesign-icons-react';
import 'react-transition-group';
import 'classnames';
import '../overlay/index.js';
import '../overlay/Overlay.js';
import 'ahooks';
import '../_chunks/dep-d5ec015e.js';
import '../_chunks/dep-b31bb48b.js';
import '../_chunks/dep-ba137374.js';
import '../_chunks/dep-6b86f47a.js';
import '../_chunks/dep-9fe8d051.js';
import '../_util/withNativeProps.js';
import '../_chunks/dep-dadffb76.js';
import '../_chunks/dep-674c58f4.js';
import '../_chunks/dep-95834911.js';
import '../_chunks/dep-0e9724f2.js';
import '../_chunks/dep-cd7df551.js';
import '../_chunks/dep-41e2f4ed.js';
import '../_chunks/dep-818f0859.js';
import '../_chunks/dep-a4df350d.js';
import '../_chunks/dep-00b2fb56.js';
import '../_chunks/dep-6b8f1e75.js';
import '../_chunks/dep-aea8138c.js';
import '../_chunks/dep-d8b4285c.js';
import '../_util/withStopPropagation.js';
import '../_util/renderToContainer.js';
import '../_util/getContainer.js';
import '../_chunks/dep-3fecfff7.js';
import '../_util/canUseDom.js';
import '../_chunks/dep-c9dcffa1.js';
import '../_util/useLockScroll.js';
import '../_util/useTouch.js';
import '../_util/getScrollParent.js';
import '../_util/supportsPassive.js';
import '../_util/useConfig.js';
import '../config-provider/ConfigContext.js';
import '../_util/useShouldRender.js';
import '../_util/useInitialized.js';
import './hooks/useMessageCssTransition.js';

var _methods$default = methods,
  fail = _methods$default.fail,
  success = _methods$default.success,
  loading = _methods$default.loading,
  warning = _methods$default.warning,
  createToast = _methods$default.createToast;
var Toast = function Toast(props) {
  return createToast(props);
};
var index = attachMethodsToComponent(Toast, {
  fail: fail,
  success: success,
  loading: loading,
  warning: warning
});

export { Toast, index as default };
//# sourceMappingURL=index.js.map
